import { useTranslation } from 'react-i18next';

const NurseSuggestionRejectedBy = ({ rejectedBy }) => {
    const { t } = useTranslation();

    return rejectedBy ? t(`rejectedBy.${rejectedBy}`) : null;
};

export default NurseSuggestionRejectedBy;
